import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {Card} from 'reactstrap';
import {productApi} from '../../../api';
import {Block, BlockHead, BlockHeadContent, BlockTitle} from '../../../components/block/Block';
import Button from '../../../components/button/Button';
import Icon from '../../../components/icon/Icon';
import {Pagination} from '../../../components/pagination/Pagination';
import {usePagination} from '../../../shared/hooks/usePagination';
import ProductFilters from './components/ProductFilters';
import ProductTable from './components/ProductTable';
import {IProduct} from './interfaces/IProduct';

const Products = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [productList, setProductList] = useState<IProduct[]>([]);

  const {changeFilterHandler, page, setTotalPages, totalPages, handlePages, pagination} = usePagination();
  useEffect(() => {
    productApi.getAllProduct(pagination).then((response) => {
      const {data} = response;
      setProductList(data.data);
      setTotalPages(Math.ceil(data?.count / data?.perPage));
    });
  }, [pagination, setTotalPages]);
  return (
    <>
      <Block size="lg" className="mt-3">
        <BlockHead>
          <BlockHeadContent>
            <div className="row align-items-center gx-0 gx-lg-2">
              <div className="col-xxl-10 col-xl-9 col-lg-8 col-12">
                <BlockTitle tag="h4">{t('management.products.productList')}</BlockTitle>
              </div>
              <div className="col-xxl-2 col-xl-3 col-lg-4 col-12  text-end">
                <Button
                  className="btn-block"
                  color="primary"
                  onClick={() => {
                    navigate('/app/management/products/create');
                  }}
                >
                  <Icon name="plus-sm" />
                  {t('management.products.addNew')}
                </Button>
              </div>
            </div>
            <ProductFilters changeFilterHandler={changeFilterHandler} pagination={pagination} />
          </BlockHeadContent>
        </BlockHead>
        <Card className="card-bordered card-preview">
          <ProductTable productList={productList} setProductList={setProductList} />
        </Card>
      </Block>

      <div className="d-flex justify-content-end">
        {totalPages <= 1 ? '' : <Pagination page={page} totalPages={totalPages} handlePagination={handlePages} />}
      </div>
    </>
  );
};

export default Products;
